import { Check, X } from "lucide-react";
import { cn } from "@repo/share-log-web-utils";
import { METHOD_ICONS } from "@web/components/ui/method-icon";

interface IconPickerProps {
  value: string | null;
  onChange: (icon: string | null) => void;
}

export function IconPicker({ value, onChange }: IconPickerProps) {
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-5 gap-1">
        {METHOD_ICONS.map(({ name, icon: Icon, label }) => (
          <button
            key={name}
            type="button"
            title={label}
            className={cn(
              "flex flex-col items-center justify-center gap-0.5 p-1.5 rounded-md transition-all",
              "hover:bg-accent hover:text-accent-foreground",
              value === name
                ? "bg-primary text-primary-foreground ring-2 ring-primary ring-offset-1"
                : "text-muted-foreground",
            )}
            onClick={() => onChange(name)}
          >
            <Icon className="h-4 w-4" />
            <span className="text-[10px] leading-tight">{label}</span>
          </button>
        ))}
      </div>

      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          {value ? (
            <>
              <Check className="h-3.5 w-3.5" />
              <span>
                {METHOD_ICONS.find((i) => i.name === value)?.label ?? value}
              </span>
            </>
          ) : (
            <>
              <X className="h-3.5 w-3.5" />
              <span>아이콘 없음</span>
            </>
          )}
        </div>
        {value && (
          <button
            type="button"
            onClick={() => onChange(null)}
            className="text-xs text-muted-foreground hover:text-foreground"
          >
            제거
          </button>
        )}
      </div>
    </div>
  );
}
